import React from 'react';
import { Box, IconButton, Popover, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import type { IDrawingBase } from 'types/IDrawingBase';
import { PrizeTypeLabel } from 'types/IPrize';
import { prizeLabel } from 'utility/prizeLabel';

import './DrawingBaseInfoPopover.scss';

interface IProps {
  drawingBase: IDrawingBase | null;
  anchorEl: HTMLElement | null;
  onClose: () => void;
}

export const DrawingBaseInfoPopover: React.FC<IProps> = ({ drawingBase, anchorEl, onClose }) => {
  if(!drawingBase) return null;

  const prizes = drawingBase?.dbasePrizes ?? [];

  return (
    <Popover
      open={Boolean(anchorEl && drawingBase)}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      disableScrollLock
      slotProps={{ paper: { className: 'psf-drawing-base-info' } }}
    >
      <IconButton className="psf-drawing-base-info__close" onClick={onClose} size="small" aria-label="Schließen">
        <CloseIcon fontSize="small" />
      </IconButton>

      <Box className="psf-drawing-base-info__head">
        <Typography className="psf-drawing-base-info__name">{drawingBase?.name || '-'}</Typography>
      </Box>

      {prizes.length === 0 ? (
        <Typography className="psf-drawing-base-info__empty">Dieser Ziehungsbasis sind keine Gewinne zugeordnet.</Typography>
      ) : (
        <Box component="table" className="psf-drawing-base-info__table">
          <tbody>
            {prizes.map((prize) => (
              <tr key={prize.id}>
                <td>{PrizeTypeLabel[prize.typ] || '-'}</td>
                <td>{prizeLabel(prize.typ, prize.value, prize.title)}</td>
              </tr>
            ))}
          </tbody>
        </Box>
      )}
    </Popover>
  );
};
